















import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class ProjectFinishedComponent extends Vue {
  @Prop() readonly wasFinalReportSend!: boolean;
  @Prop() readonly projectFinishedText!: string;
}
